











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import AuthenticationService from '@/domain/security/authentication.service';
import AuthorityService from '@/domain/security/authority.service';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import EventBus, { Event } from '@/event.bus';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import MyAccountModal from './my-account-modal.component.vue';
import menuItemsData from './menu-items.json';

interface MenuItem {
  label: string;
  icon: string;
  path?: string;
  routeNames: string[];
  enabled?: boolean;
  authorities?: string[];
  profiles?: string[];
  children?: MenuItem[];
}

const avatarUser = require('@/assets/images/avatar.png');

@Component({
  components: {
    MyAccountModal,
  },
})
export default class Menu extends Vue {
  @Prop({ default: true }) open!: boolean;

  photo: string = avatarUser;

  userAuthorities: string[] = [];

  currentProfile: string = '';

  showMyAccountModal: boolean = false;

  readonly menuItems: MenuItem[] = menuItemsData;

  created() {
    /* eslint prefer-template: "off" */
    AuthenticationService.photo()
      .then((response: any) => { this.photo = 'data:image/png;charset=utf-8;base64,' + response[0].body; });
    AuthorityService.authorities()
      .then((resp: string[]) => { this.userAuthorities = resp; });
    this.currentProfile = UserBusinessUnitService.currentBusinessUnit?.profile || '';
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (bu: BusinessUnit) => {
      this.currentProfile = bu.profile || '';
    });
  }

  private isVisible(item: MenuItem): boolean {
    if (item.enabled === false) return false;
    const hasAuthRestriction = !!(item.authorities && item.authorities.length > 0);
    const hasProfileRestriction = !!(item.profiles && item.profiles.length > 0);
    if (!hasAuthRestriction && !hasProfileRestriction) return true;
    const authMatch = hasAuthRestriction
      && item.authorities!.some((a) => this.userAuthorities.includes(a));
    const profileMatch = hasProfileRestriction && item.profiles!.includes(this.currentProfile);
    return authMatch || profileMatch;
  }

  get visibleMenuItems(): MenuItem[] {
    return this.menuItems.filter((item) => this.isVisible(item));
  }

  visibleChildren(item: MenuItem): MenuItem[] {
    return (item.children ?? []).filter((child) => this.isVisible(child));
  }

  get name(): string {
    return AuthenticationService.userLoggedIn().name;
  }

  get isProductionMode(): boolean {
    return process.env.NODE_ENV === 'production';
  }

  logout(): void {
    AuthenticationService.logout();
  }

  openMyAccount(): void {
    this.showMyAccountModal = true;
  }

  go(path: string): void {
    this.$router.push(path);
  }

  isActive(item: MenuItem): boolean {
    if (!this.$route.name) return false;
    return item.routeNames.some((name) => this.$route.name!.includes(name));
  }
}
